import type { ReactNode } from 'react';

import OpenPixContext from './OpenPixContext.tsx';
import { useStore } from './useStore.tsx';
import type { OpenPixStoreState } from '../dataLayer/OpenPixStore.tsx';
import { getInitialState } from '../dataLayer/OpenPixStore.tsx';

type Props = {
  children: React.ReactNode;
  initialOpenPixState?: OpenPixStoreState;
};
const OpenPixProvider = ({
  children,
  initialOpenPixState = getInitialState(), // keep a external store after plugin loading
}: Props): ReactNode => {
  const [openPixState, setOpenPixState] =
    useStore<OpenPixStoreState>(initialOpenPixState);

  return (
    <OpenPixContext.Provider
      value={{
        setOpenPixState,
        openPixState,
      }}
    >
      {children}
    </OpenPixContext.Provider>
  );
};

export default OpenPixProvider;
